export default "__VITE_ASSET__CgLNw0B4__"